import Dimensions, { scalePixelsToFontSize } from "../constants/styles/dimensions";
import { calcTextSize } from "./calcTextSize";

const { MAX_ITEM_TEXT_WIDTH } = Dimensions;

const getLabelWithUntitled = value => (value && value.length ? value : "Untitled");
const getValueWithNone = (value, defaultLabel = "None") => (value && value.length ? value : defaultLabel);

const getTextMetrics = (text, fontSize, widthMap, maxWidth = MAX_ITEM_TEXT_WIDTH) => {
  const scaledMaxWidth = scalePixelsToFontSize(maxWidth, fontSize);
  return calcTextSize(text, fontSize, widthMap, scaledMaxWidth, true);
};

/**
 * The max width will be scaled when calculating
 * @param {string} text
 * @param {Immutable.Map} widthMap
 * @param {number} fontSize
 * @param {number} maxWidth
 * @returns
 */
const getMetricsLabelSize = (text, widthMap, fontSize = Dimensions.BASE_FONT_SIZE, maxWidth = MAX_ITEM_TEXT_WIDTH) => {
  const untitledText = getLabelWithUntitled(text);
  const metricsSize = getTextMetrics(untitledText, fontSize, widthMap, maxWidth).size;
  let size = metricsSize.toJS();
  return size;
};

export { getLabelWithUntitled, getMetricsLabelSize, getValueWithNone };
